import React, { useRef } from 'react'
import { Typography } from '@mui/material'
import CustomAlertModal from '../customAlertModal/CustomAlertModal'
import { useTranslation } from 'react-i18next'
import CustomAlert from '../customAlert/CustomAlert'

interface Props {
  open: boolean
  onEasterEgg?: () => void
  onClose?: () => void
  onConfirm?: () => void
  message?: string
  loading?: boolean
  body?: React.ReactNode
  cancelLabel?: string
}

const ConfirmModal: ReactFC<Props> = ({
  open,
  onEasterEgg,
  onClose,
  onConfirm,
  message,
  loading,
  body,
  cancelLabel
}) => {
  const { t } = useTranslation()
  const easterEggClickCounter = useRef(0)
  const cleanEasterEggCounterTimeout = useRef<NodeJS.Timeout | undefined>()
  const handleClickIcon = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    cleanEasterEggCounterTimeout.current &&
      clearTimeout(cleanEasterEggCounterTimeout.current)
    easterEggClickCounter.current++
    if (easterEggClickCounter.current === 3) {
      if (onEasterEgg === undefined) return
      onClose?.()
      onEasterEgg()
    }
    cleanEasterEggCounterTimeout.current = setTimeout(() => {
      easterEggClickCounter.current = 0
    }, 500)
  }
  return (
    <CustomAlertModal
      onClickIcon={handleClickIcon}
      open={open}
      sx={{
        width: {
          base: 325,
          md: 500
        }
      }}
      type='warning'
    >
      <CustomAlert.Title>{t('labels.ATTENTION!')}</CustomAlert.Title>
      <CustomAlert.Body>
        {body ?? <Typography>{message ?? t('texts.Are_you_sure')}</Typography>}
      </CustomAlert.Body>
      <CustomAlert.Footer>
        <CustomAlert.CancelButton
          disabled={loading}
          onClick={(e) => {
            e.preventDefault()
            onClose?.()
          }}
        >
          {cancelLabel ?? t('buttons.Cancel')}
        </CustomAlert.CancelButton>
        <CustomAlert.Button
          loading={loading}
          onClick={(e) => {
            e.preventDefault()
            onConfirm?.()
          }}
        >
          {t('buttons.Accept')}
        </CustomAlert.Button>
      </CustomAlert.Footer>
    </CustomAlertModal>
  )
}
export default ConfirmModal
